<template>
  <div class="card">
    <button class="btn" @click="onCreateNewProject">
      Add custom selection
    </button>
  </div>
</template>

<script>
export default {
  methods: {
    onCreateNewProject() {
      this.$emit('createNewProject');
    }
  }
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/dark.less';
@import '../assets/common.less';

.card {
  margin: 0;
  display: flex;
  background-color: @gray-14;
  padding: @font-size-xxl @font-size-mlg;
}
.btn {
  margin: auto !important;
}
</style>
